<template>
    <modal name="create_role" height="auto" scrollable adaptive>
        <app-card :title="$t('Create role')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="store(validate)">
                    <app-input id="name" v-model="form.name" name="name" rules="required">
                        <template #label>
                            {{ $t('Name') }}*
                        </template>
                    </app-input>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Save') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import RoleService from '@services/role.service';

export default {
    data() {
        return {
            form: {
                name: ''
            },
            loading: false
        };
    },
    methods: {
        store(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    RoleService.store(this.form).then(res => {
                        this.$toastr.s(this.$t('Saved'));
                        this.loading = false;
                        this.$emit('setRole', res);
                        this.hide();
                    });
                }
            });
        },
        hide() {
            this.$modal.hide('create_role');
        }
    }
};
</script>
